import { defer, type Deferred } from '$lib/utils/deferred.js';
import type { lazy, asyncLazy } from '$lib/utils/types.js';

export function singletonValue<T>(value: T): lazy<T> {
    return () => {
        return value;
    };
}

export default function singleton<T>(factory: lazy<T>): lazy<T> {
    let value: T | null = null;
    return () => {
        if (value === null) {
            value = factory();
            return value;
        }
        return value;
    };
}

export function asyncSingleton<T>(factory: asyncLazy<T>): asyncLazy<T> {
    let pendingDeferred: Array<Deferred<T>> = [];
    let value: T | null = null;
    let pending = false;

    return async () => {
        if (value === null) {
            const deferred = defer<T>();
            pendingDeferred.push(deferred);

            if (!pending) {
                pending = true;
                value = await factory();

                for (const d of pendingDeferred) {
                    d.resolve(value);
                }
                pendingDeferred = [];
            }

            return await deferred.promise;
        } else {
            return value;
        }
    };
}
